// extracted by mini-css-extract-plugin
export default {"skewdiv":"SkewDiv_skewdiv__9rWnx"};